var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultAvatarW = function SvgDefaultAvatarW(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.1 55.4c1.5 0 1.9-1 2.6-2.6 1.4-3.5 4.5-12 7.2-19.9 1-2.9 1.8-4.4 2.7-5 1.8-.2 2.5-.6 2.5-1.3 0-1-1.9-1.6-5.5-1.6-4 0-6.1.5-6.1 1.6 0 .8.8 1.2 3.7 1.3.4.7.1 2.9-.8 5.7-1.1 3.8-3.4 10.7-5.4 15.7-1.9-4.6-3.6-9.2-5.2-14.8-1.2-3.9-1.4-6-1-6.6 2.6-.2 3.4-.4 3.4-1.3 0-1-2-1.7-6.5-1.7-4.2 0-6.3.6-6.3 1.8 0 .8.8 1.1 2.4 1.2.5.3.8.8 1.9 4.1l1 3c-1.4 3.9-3.7 10.1-5.5 14.5-2-4.5-3.8-9.4-5.6-15-1.3-3.9-1.6-5.9-1.2-6.5 2.1-.2 2.9-.5 2.9-1.3 0-1-1.9-1.7-6.1-1.7-4.3 0-6.4.6-6.4 1.8 0 .8.7 1.2 2.5 1.3.5.2 1 .8 2.1 4 2.5 7 6.3 17 8 20.9.8 1.7 1.3 2.5 2.7 2.5 1.4 0 1.8-1 2.5-2.6 1-2.4 3.2-8 5.4-13.7 1.8 5.2 3.9 10.8 5.2 13.7.9 1.7 1.6 2.5 2.9 2.5z"
  })));
};
export default SvgDefaultAvatarW;